export const COLORS = {
  background: 0x031628,
  ocean: {
    deep: 0x031628,
    mid: 0x053a5c,
    light: 0x0b6f8f,
    surface: 0x1fb6c5,
    glow: 0x66f2ff,
    seabed: 0x04111d
  },
  bottle: {
    glass: 0xffffff,
    glassHighlight: 0xffffff,
    rim: 0xb8c2cc,
    shadow: 0x6f7b86,
    glow: 0x7bdcff,
    base: 0xff9f3f
  },
  water: {
    red: 0xff2d2d,
    blue: 0x1f6fff,
    green: 0x00c853,
    yellow: 0xffc400,
    purple: 0x8e44ff
  },
  slot: {
    background: 0x0e2a3a,
    border: 0x66c5ff,
    highlight: 0xa7ebff,
    filled: 0x35c86b,
    chest: {
      base: 0xffb84d,
      lid: 0xffd374,
      metal: 0x8a4f0f,
      glow: 0xfff2b3
    }
  },
  ui: {
    button: {
      background: 0x86d8ff,
      hover: 0xa7e9ff,
      pressed: 0x5bbbe6,
      disabled: 0x4a7a93,
      glow: 0xd8fbff
    },
    text: {
      primary: 0xf3fdff,
      secondary: 0x9fd3e3,
      accent: 0xffd36b
    }
  },
  particles: {
    sparkle: 0xfff3b0,
    droplet: 0x86d8ff,
    confetti: [
      0xff6b6b,
      0x4fc3ff,
      0x4dffb3,
      0xffd166,
      0xc77dff
    ]
  }
};

export const WATER_COLORS = {
  red: COLORS.water.red,
  blue: COLORS.water.blue,
  green: COLORS.water.green,
  yellow: COLORS.water.yellow,
  purple: COLORS.water.purple
};

export function getWaterColor(color: "red" | "blue" | "green" | "yellow" | "purple"): number {
  return WATER_COLORS[color];
}

export function getWaterColorName(hex: number): "red" | "blue" | "green" | "yellow" | "purple" | null {
  for (const [name, value] of Object.entries(WATER_COLORS)) {
    if (value === hex) {
      return name as "red" | "blue" | "green" | "yellow" | "purple";
    }
  }
  return null;
}

// Re-export from style.ts for convenience
export { DIMENSIONS, SPACING, Z_INDEX, ANIMATION, OPACITY, SCALE } from "./style";
